var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_724_12785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9373 8.73602C23.8603 8.4986 23.7154 8.28901 23.5203 8.13328C23.3253 7.97754 23.0888 7.88252 22.8403 7.86L15.9122 7.23102L13.1742 0.820756C12.972 0.349794 12.512 0.0458984 12.0001 0.0458984C11.4881 0.0458984 11.028 0.349794 10.8271 0.820756L8.08907 7.23102L1.15989 7.86C0.651896 7.90688 0.221763 8.25095 0.0628544 8.73602C-0.0145781 8.97365 -0.0206013 9.22877 0.0455309 9.46978C0.111663 9.7108 0.247045 9.92712 0.434908 10.092L5.67201 14.6841L4.12788 21.4852C4.01491 21.9852 4.20897 22.5024 4.62392 22.8023C4.84125 22.9604 5.10315 23.0455 5.37192 23.0453C5.6023 23.0453 5.82836 22.9828 6.02597 22.8643L12.0001 19.2923L17.9731 22.8643C18.1873 22.9925 18.4345 23.055 18.684 23.044C18.9334 23.0329 19.1741 22.9489 19.3763 22.8023C19.7912 22.5024 19.9853 21.9852 19.8723 21.4852L18.3281 14.6841L23.5652 10.092C23.7531 9.92718 23.8885 9.71086 23.9546 9.46984C24.0208 9.22882 24.0147 8.97369 23.9373 8.73607V8.73602Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_724_12785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBig);
export default __webpack_public_path__ + "static/media/star_big.6ced2102752f35ba4a1c6f76e0911f45.svg";
export { ForwardRef as ReactComponent };